var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{staticClass:"chip",attrs:{"small":"","color":_vm.COLORS_BY_ENTITY[_vm.entityType]}},[_c('EntityIcon',{staticClass:"me-1",attrs:{"entityType":_vm.entityType}}),_c('p',{staticClass:"caption pa-0 ma-0",class:_vm.TEXT_COLORS_BY_ENTITY[_vm.entityType]},[_vm._v("\n    "+_vm._s(_vm.entityName)+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }